import Vue from 'vue';
import Vuex, { Store, StoreOptions } from 'vuex';

import productsModule from '@/store/entityModules/ProductsModule';
import colorsModule from '@/store/entityModules/ColorsModule';
import categoriesModule from '@/store/entityModules/CategoriesModule';
import userModule from '@/store/modules/UserModule';
import uiModule from '@/store/modules/UIModule';
import quantityBreaksModule from '@/store/entityModules/QuantityBreaksModule';
import colorGroupsModule from '@/store/entityModules/ColorGroupsModule';
import productionTimesModule from '@/store/entityModules/ProductionTimesModule';
import preorderProductsModule from '@/store/entityModules/PreorderProductsModule';
import fontsModule from '@/store/entityModules/FontsModule';
import fontGroupsModule from '@/store/entityModules/FontGroupsModule';

import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
import { UploadEndpoints } from '@/api/endpoints/UploadEndpoints';
import productCategoryOptionsModule from '@/store/entityModules/ProductCategoryOptionsModule';
import productCategoryAttributesModule from '@/store/entityModules/ProductCategoryAttributesModule';
import shopifyProductsModule from '@/store/entityModules/ShopifyProductsModule';
import { ImageFileDTO } from '@/api/dto/ImageFileDTO';
import { ImageFile } from '@/models/entities/ImageFile';
import { ImageFileMapper } from '@/models/mappers/ImageFileMapper';
const ls = new SecureLS({ encodingType: 'aes' });

Vue.use(Vuex);

export interface RootState {}

const storeOptions: StoreOptions<RootState> = {
  /**
   * Entity modules names must be the same as
   * `./utils.ts` getEntityStorePath() return values
   */
  modules: {
    // entity modules:
    productsModule: productsModule,
    shopifyProductsModule: shopifyProductsModule,
    colorsModule: colorsModule,
    categoriesModule: categoriesModule,
    quantityBreaksModule: quantityBreaksModule,
    colorGroupsModule: colorGroupsModule,
    productCategoryOptionsModule: productCategoryOptionsModule,
    productCategoryAttributesModule: productCategoryAttributesModule,
    productionTimesModule: productionTimesModule,
    preorderProductsModule: preorderProductsModule,
    fontsModule: fontsModule,
    fontGroupsModule: fontGroupsModule,

    // non-entity modules:
    userModule: userModule,
    uiModule: uiModule,
  },

  plugins: [
    createPersistedState({
      key: 'admin-spa-vuex',
      paths: ['userModule.userInfo'],
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key),
      },
    }),
  ],

  actions: {
    async uploadFile({ state, commit, dispatch }, image: File): Promise<ImageFile> {
      const authClient = new UploadEndpoints();
      const uploadResult: ImageFileDTO = await authClient.uploadImage(image);
      const imageMapper = new ImageFileMapper();
      return imageMapper.mapFromDTO(uploadResult);
    },
  },
};

const store: Store<RootState> = new Vuex.Store<RootState>(storeOptions);
export default store;
